import { DollarApollo } from "vue-apollo/types/vue-apollo";
import { FetchResult } from "apollo-link";
import Mutation from "./mutation.gql";

export interface RawResult {
  updateBuilding: boolean;
}

export type Args = {
  buildingId: string;
  groupId?: string;
};

export const updateBuildingGroup = async <V>(
  apollo: DollarApollo<V>,
  args: Args
): Promise<FetchResult<RawResult>> => {
  const { buildingId, groupId } = args;
  const result = apollo.mutate<RawResult>({
    mutation: Mutation,
    variables: {
      buildingId,
      groupId
    }
  });
  await apollo.provider.defaultClient.cache.reset();
  return result;
};
